import { CampaignStatus } from "models";

export const ACTIVE_CAMPAIGN_STATUSES = [
  CampaignStatus.AWAITING_DELIVERY,
  CampaignStatus.PARTIALLY_DELIVERED,
  CampaignStatus.DELIVERED,
  CampaignStatus.COPY_MISSING,
  CampaignStatus.CHECKED,
  CampaignStatus.SENT_TO_PRINT,
  CampaignStatus.SCHEDULED,
  CampaignStatus.CAP_PENDING,
  CampaignStatus.CAP_APPROVED,
  CampaignStatus.CAP_REJECTED,
  CampaignStatus.CAP_PARTIALLY_REJECTED,
  CampaignStatus.API_ERROR,
  CampaignStatus.API_PENDING,
  CampaignStatus.API_PARTIALLY_REJECTED,
  CampaignStatus.API_REJECTED,
  CampaignStatus.API_APPROVED,
  CampaignStatus.ZIP_DELIVERED,
  CampaignStatus.APPROVED,
  CampaignStatus.REJECTED,
];

export const CAMPAIGN_ALREADY_CHECKED = [CampaignStatus.SENT_TO_PRINT, CampaignStatus.SCHEDULED];

export const INACTIVE_CAMPAIGN_STATUSES = [CampaignStatus.CANCELLED, CampaignStatus.ARCHIVED];
